import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";

export default function BlogList() {
  const { t } = useLang();
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoaded(true)); }, []);

  return (
    <div className="relative min-h-screen">
      <div className="vl-noise" />
      <Header />
      <section className="max-w-7xl mx-auto px-6 sm:px-8 pt-32 pb-20" data-testid="blog-list">
        <div className="text-center mb-14">
          <div className="text-xs tracking-[0.35em] uppercase text-[var(--vl-gold)] mb-3">Veloura</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[var(--vl-ivory)]">{t("blog_title")}</h1>
          <p className="text-sm text-[var(--vl-stone)] mt-3">{t("blog_sub")}</p>
        </div>
        {loaded && posts.length === 0 && <p className="text-center text-[var(--vl-stone)] py-16">—</p>}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug}`} key={p.id} className="vl-card rounded-2xl overflow-hidden group block" data-testid={`blog-card-${p.slug}`}>
              {p.cover && <div className="h-56 overflow-hidden"><img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>}
              <div className="p-6">
                <div className="text-[10px] tracking-widest uppercase text-[var(--vl-gold)] mb-2">{new Date(p.date).toLocaleDateString()}</div>
                <h3 className="font-serif-display text-xl text-[var(--vl-ivory)]">{p.title}</h3>
                {p.excerpt && <p className="text-sm text-[var(--vl-stone)] mt-2 line-clamp-3">{p.excerpt}</p>}
                <span className="text-sm text-[var(--vl-gold)] mt-4 inline-flex items-center gap-1">{t("read_more")} <ArrowRight size={14} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
